import { FC, useMemo, useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { useMethods } from '@lhb/hook';
import V2Container from '@/common/components/Data/V2Container';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import V2Title from '@/common/components/Feedback/V2Title';
import PointList from '@/common/components/business/PointLibraryList';
import styles from './SlowFlashPoints.module.less';

const FIRST_PAGE_SIZE = 4;
const PREVIEW_LIST_HEIGHT = 480;

const SlowFlashPoints: FC<{
  placePublicId?: number | string;
  onViewRecord?: (record: any) => void;
  onOpenVideoDetail?: (record: any) => void;
  onOpenRoi?: (record: any) => void;
}> = ({
  placePublicId,
  onViewRecord,
  onOpenVideoDetail,
  onOpenRoi,
}) => {
  const [total, setTotal] = useState<number>();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [drawerMainHeight, setDrawerMainHeight] = useState<number>(0);
  const filters = useMemo(() => ({ placePublicId }), [placePublicId]);
  const methods = useMethods({
    handlePreviewDataLoaded(data: { total: number }) {
      setTotal(data.total);
    },
    handleOpenDrawer() {
      setDrawerOpen(true);
    },
    handleCloseDrawer() {
      setDrawerOpen(false);
    },
  });

  if (!placePublicId || total === 0) {
    return null;
  }
  const totalCount = total || 0;

  return (
    <div className={styles.slowFlashPoints}>
      <V2Title
        divider
        type='H2'
        text={`场地点位（${totalCount}）`}
        extra={totalCount > FIRST_PAGE_SIZE ? <button type='button' className={styles.moreButton} onClick={methods.handleOpenDrawer}>查看更多<RightOutlined /></button> : null}
      />
      <PointList
        filters={filters}
        mainHeight={PREVIEW_LIST_HEIGHT}
        initialPageSize={FIRST_PAGE_SIZE}
        hidePagination
        fitContentHeight
        displayMode='areaDetail'
        allowProjectJump={false}
        onViewRecord={onViewRecord}
        onOpenVideoDetail={onOpenVideoDetail}
        onOpenRoi={onOpenRoi}
        onDataLoaded={methods.handlePreviewDataLoaded}
      />
      <V2Drawer
        open={drawerOpen}
        contentWrapperStyle={{
          width: '90%',
          minWidth: '921px', // 1024*0.9
          maxWidth: 'auto',
        }}
        destroyOnClose
        onClose={methods.handleCloseDrawer}
        push={false}
      >
        <V2Container
          style={{ height: 'calc(100vh - 48px)' }}
          emitMainHeight={(height) => setDrawerMainHeight(height)}
          extraContent={{
            top: <div className={styles.drawerTitle}>场地点位</div>,
          }}
        >
          <PointList
            filters={filters}
            mainHeight={drawerMainHeight}
            initialPageSize={20}
            hidePagination={false}
            displayMode='areaDetail'
            allowProjectJump={false}
            onViewRecord={onViewRecord}
            onOpenVideoDetail={onOpenVideoDetail}
            onOpenRoi={onOpenRoi}
          />
        </V2Container>
      </V2Drawer>
    </div>
  );
};

export default SlowFlashPoints;
